import { createAction } from '@reduxjs/toolkit';

export const UPDATE_MESSAGE_STATUS_ACTION_TYPE = 'saga/updateMessageStatus';
export const updateMessageStatusAction = createAction(UPDATE_MESSAGE_STATUS_ACTION_TYPE);
